import { gql } from '@apollo/client';

export const SET_PRIORITY_TAG = gql`
  mutation setPriorityTag($eventRequestId: String!, $tagId: String!) {
    setPriorityTag(event_request_id: $eventRequestId, tag_id: $tagId) {
      status
    }
  }
`;
